<template>
  <div>
    <!-- 隐藏传参,不需要反馈,只需要占个坑 -->

  </div>
</template>

<script>
  //
  export default {
    name: "hj-none",
    data() {
      return {
        
      }
    },
    props: {
      inData: {
        type: String,
        default: ''
      }
    },
    created() {
      // console.log(this.pre_item);
    },
    activated: function() {
      // console.log('keep-alive 组件激活时调用 hj-input激活');
      
    },
    deactivated: function() {
      // console.log('keep-alive 组件激活时调用 hj-input停用');
    },
    methods: {
    }
  }
</script>


